import FileUpload from './components/FileUpload'
export default FileUpload
export { FileSize } from './interfaces'
export type {
  ChangeDetail,
  FileMetadata,
  FileType,
  FileUploadProps
} from './interfaces'
